/*****************************************************************************/
/*  File Name: tierSelect.js                                                 */
/*  Date:      June 21, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This will handle the tier selection of the systems on the
/*             bottom half of the bar
/*
/*****************************************************************************/

import React /* useState,*/ from 'react';
import { withTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import styles from './styles/roi.module.scss';
import { MenuItem, Typography } from '@mui/material';
import { useROIContext } from '../../context/roiContext';

import { convertToCurrency } from '../../functions/convertCurrency';
import { useTierContext } from '../../context/tierContext';
import * as TIMERANGE from '../../constants/timeRanges';
import TierLogo from './functions/getTierIcon';
import SoltaSelect from './elements/SelectField';
import * as MODE from '../../constants/modes';
import SystemTextField from './elements/SystemTextField';
import { convertToNumber } from '../../functions/convertNumber';

function TierSelect({ t }) {
  //Load all of the default component varaibles

  const { selectedTier, setSelectedTier, nextTier, setSelectedTimeRange, selectedTimeRange, roiMode, currentSpend, setCurrentSpend } = useROIContext();
  const { tiers, tiersLoading } = useTierContext();
  //console.log(tiers);
  return (
    <Grid item xs={12} container>
      <Grid item xs={12} className={styles.title}>
        Treatment Assumption Timeframe
      </Grid>
      <Grid item xs={12} container className={styles.rangeSelect}>
        <Grid item xs onClick={() => setSelectedTimeRange(TIMERANGE.weekly)} className={`${styles.select} ${selectedTimeRange === TIMERANGE.weekly ? styles.selected : ''}`}>
          {TIMERANGE.weekly}
        </Grid>
        <Grid item xs onClick={() => setSelectedTimeRange(TIMERANGE.monthly)} className={`${styles.select} ${selectedTimeRange === TIMERANGE.monthly ? styles.selected : ''}`}>
          {TIMERANGE.monthly}
        </Grid>
      </Grid>
      <Grid item xs={12} className={styles.title}>
        SELECT PRICING TIER
      </Grid>
      <Grid item xs={12} className={styles.selectTierGrid}>
        {!tiersLoading ? (
          <SoltaSelect labelId='tier-select' id='tier-select' fullWidth value={selectedTier} onChange={(event) => setSelectedTier(event.target.value)}>
            {tiers.map((tier) =>
              tier.tierName !== 'Bronze' && tier.tierName !== 'Silver' ? (
                <MenuItem value={tier.id} key={tier.id}>
                  <Grid item xs container alignItems='center' className={styles.tierDropdown}>
                    <Grid item xs={2} className={styles.tierImage}>
                      {TierLogo({ tier: tier.tierName })}
                    </Grid>
                    <Grid item xs={10}>
                      <Typography className={styles.tierName}>
                        {tier.tierName} <span className={styles.price}>- ${convertToCurrency(tier.min)}</span>
                      </Typography>
                    </Grid>
                  </Grid>
                </MenuItem>
              ) : null
            )}
          </SoltaSelect>
        ) : (
          ''
        )}
      </Grid>

      {roiMode === MODE.capital ? (
        nextTier.tierName ? (
          <>
            <Grid item xs={12} className={styles.title}>
              NEXT TIER
            </Grid>
            <Grid item xs={12} className={styles.nextTier} container>
              <Grid item xs={2} className={styles.tierImage}>
                {TierLogo({ tier: nextTier.tierName })}
              </Grid>
              <Grid item xs={10}>
                <Typography className={styles.tierName}>
                  {nextTier.tierName} <span className={styles.price}>- ${convertToCurrency(nextTier.min)}</span>
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          ''
        )
      ) : (
        <>
          {/* <Grid item xs={12} className={styles.title}>
            Current Spend
          </Grid>
          <Grid item xs={12} className={styles.nextTier} container>
            <SystemTextField
              InputProps={{
                startAdornment: '$',
              }}
              id={`current-spent`}
              variant='standard'
              value={convertToCurrency(currentSpend)}
              onChange={(event) => setCurrentSpend(convertToNumber(event.target.value))}
            />
          </Grid> */}
        </>
      )}
    </Grid>
  );
}

export default withTranslation()(TierSelect);
